export const ARCHIVED_PRODUCT_TYPES = ["DevOps-Squad", "O365"];

export function isArchivedProductType(productType: string): boolean {
  return ARCHIVED_PRODUCT_TYPES.includes(productType);
}

export function getProductTypeOptionLabel(productType: string): string {
  return isArchivedProductType(productType)
    ? `${productType} (Archived)`
    : productType;
}

export function getContextualProductTypeOptions(
  available: string[],
  current: string[],
  allowArchived = false
): string[] {
  const options = available.filter(
    (productType) =>
      allowArchived ||
      !isArchivedProductType(productType) ||
      current.includes(productType)
  );
  current
    .filter(isArchivedProductType)
    .forEach((productType) => options.push(productType));
  return Array.from(new Set(options));
}

export function retainSelectableProductTypes(
  next: string[],
  current: string[]
): string[] {
  return next.filter(
    (productType) =>
      !isArchivedProductType(productType) || current.includes(productType)
  );
}
